import { useTranslation } from 'next-i18next'
import React from 'react'
import Fallback from './Fallback'

const error = '../../assets/error.png'

const Error = (props) => {
  const { t } = useTranslation()

  return (
    <Fallback image={error} altImage={t('page.error.alt')} text={props.isPageLevel ? t('page.error.text') : t('page.content.error.text')} {...props} />
  )
}

export default Error
